'use client';

import { CheckoutPage } from './CheckoutPage';

export const LegacyCheckoutPage = (props: {
  showExtraSavings?: boolean;
  showFlashMessageOnCheckoutSuccess?: boolean;
}) => (
  <CheckoutPage {...props} navigateToProductSelectionMethod="searchParam" />
);
